import React, { useState } from "react";
import {
  IconLayoutDashboard,
  IconTools,
  IconHome,
  IconFlask2,
  IconStethoscope,
  IconComponents,
  IconPrinter,
} from '@tabler/icons-react';
import { Menu, ActionIcon } from '@mantine/core';

import { TemplateModal } from "./TemplateModal";
import { leftNavMenuProps } from "../styleFile";

export const TemplateDropdown = ({ projectKey, iconColour, leftNav = false }) => {

  const [category, setCategory] = useState(null)
  const [open, setOpen] = useState(false)
  const [hover, setHover] = useState(false)

  const handleSelect = (data) => {
    setCategory(data.value)
    setOpen(true)
  }


  const categories = [
    { value: 'Construction', label: 'Construction template' },
    { value: 'Education', label: 'Education template' },
    { value: 'Home', label: 'Home template' },
    { value: 'Medical', label: 'Medical template' },
    { value: 'Menu', label: 'Menu template' },
    { value: 'Office', label: 'Office template' },
  ]

  const closeModal = () => {
    setOpen(false)
  }

  return (
    <>
        <Menu
          transitionProps={{ transition: 'pop' }}
          withinPortal
          trigger="click-hover"
          {...(leftNav ? leftNavMenuProps : {})}
        >
          <Menu.Target>
            <ActionIcon
              size={leftNav ? 28 : undefined}
              radius={leftNav ? 12 : undefined}
              variant="transparent"
              color={!hover ? iconColour.normal : iconColour.hover}
              onPointerOver={() => setHover(true)}
              onPointerLeave={() => setHover(false)}
              style={
                leftNav
                  ? {
                      backgroundColor: hover ? (iconColour?.hoverBg || "#f3f4f6") : "transparent",
                      border: hover ? `1px solid ${iconColour?.border || "#e5e7eb"}` : "1px solid transparent",
                    }
                  : undefined
              }
            >
              <IconLayoutDashboard size={18} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item value="Construction" onClick={() => handleSelect(categories[0])} leftSection={<IconTools size={18} />}>Construction templates</Menu.Item>
            <Menu.Item value="Education" onClick={() => handleSelect(categories[1])} leftSection={<IconFlask2 size={18} />}>Education templates</Menu.Item>
            <Menu.Item value="Home" onClick={() => handleSelect(categories[2])} leftSection={<IconHome size={18} />}>Home templates</Menu.Item>
            <Menu.Item value="Medical" onClick={() => handleSelect(categories[3])} leftSection={<IconStethoscope size={18} />}>Medical templates</Menu.Item>
            <Menu.Item value="Menu" onClick={() => handleSelect(categories[4])} leftSection={<IconComponents size={18} />}>Menu templates</Menu.Item>
            <Menu.Item value="Office" onClick={() => handleSelect(categories[5])} leftSection={<IconPrinter size={18} />}>Office templates</Menu.Item>

          </Menu.Dropdown>
        </Menu>
      <TemplateModal projectKey={projectKey} category={category} open={open} close={closeModal} />
    </>
  );
};





